module.exports = __webpack_public_path__ + "img/air_purple.83292989.svg";